import conf from './_conf';
import diffType from './_type';
import { workName } from './_upload';
import { emitEnter } from './_enter';
import { emitEvent } from './_event';

let saveRes = {};

const addEvent = (key, newValue) => {
  if (saveRes[key] == newValue) return;
  if (typeof saveRes[key] == 'undefined') {
    saveRes[key] = newValue;
    return;
  }

  let _itemConf = conf[workName].observer[key];

  let preConfV = _itemConf.pre;
  let nowConfV = _itemConf.now;
  let notconfV = _itemConf.not;

  // 是否相等
  let isEqual =
    diffType.equal == _itemConf.diffType &&
    preConfV !== undefined &&
    nowConfV !== undefined &&
    saveRes[key] === preConfV &&
    newValue === nowConfV;

  // 是否不同
  let isDiffrent =
    diffType.different == _itemConf.diffType &&
    preConfV == undefined &&
    nowConfV == undefined &&
    saveRes[key] !== newValue;

  // 是否不同且不等
  let isNotEqual = false;
  if (
    diffType.noEqual == _itemConf.diffType &&
    Array.isArray(notconfV) &&
    notconfV.length
  ) {
    let isMatch = !!~notconfV.findIndex(item => item == newValue);
    if (!isMatch && saveRes[key] !== newValue) {
      isNotEqual = true;
    }
  }

  // 是否不为空数组且有变更
  let isNotEmptyArray = false;
  if (diffType.noEmptyArray == _itemConf.diffType && Array.isArray(newValue)) {
    if (newValue.length && String(newValue) !== String(saveRes[key])) {
      isNotEmptyArray = true;
    }
  }

  // 是否从空数组变为非空数组
  let isNotEmptyArrayPre = false;
  if (
    diffType.noEmptyArrayPre == _itemConf.diffType &&
    Array.isArray(newValue) &&
    Array.isArray(saveRes[key])
  ) {
    if (!saveRes[key].length && newValue.length) {
      isNotEmptyArrayPre = true;
    }
  }

  // 是否符合静态条件
  let staticCondition = true;
  if (_itemConf.staticCondition) {
    for (let itemkey in _itemConf.staticCondition) {
      if (saveRes[itemkey] !== _itemConf.staticCondition[itemkey]) {
        staticCondition = false;
        break;
      }
    }
  }

  if (
    (isEqual ||
      isDiffrent ||
      isNotEqual ||
      isNotEmptyArray ||
      isNotEmptyArrayPre) &&
    staticCondition
  ) {
    switch (conf[workName].observer[key].action) {
      case 'enter':
        emitEnter(key);
        break;
      case 'event':
        emitEvent(key);
        break;
      default:
        break;
    }
  }
  saveRes[key] = newValue;
};

export const rewriteDefineproperty = () => {
  let _oldDefineProperty = Object.defineProperty;
  Object.defineProperty = function (obj, key, props) {
    try {
      let _itemConf = conf[workName].observer[key];
      if (_itemConf) {
        // 对于vuex和vue内的数据分别处理
        let observerDateType = _itemConf.type;
        if (observerDateType == 'computed') {
          let _oldGet = props.get;
          props.get = function () {
            let args = Array.prototype.slice.call(arguments);
            let res = _oldGet.apply(this, args);
            addEvent(key, res);
            return res;
          };
        }
        if (observerDateType == 'data' && obj.$data) {
          let curTag = obj.$vnode.tag;
          let curVueRes = curTag.match(/^vue-component-[0-9]+-([^]+)$/);
          // 判断是否目标组件内的属性，避免同名属性干扰
          if (curVueRes && _itemConf.page == curVueRes[1]) {
            let _oldSet = props.set;
            // 记录默认值
            if (obj.$data[key] !== undefined) {
              saveRes[key] = obj.$data[key];
            }
            // 保存静态条件值
            if (_itemConf.staticCondition) {
              for (let itemkey in _itemConf.staticCondition) {
                saveRes[itemkey] = obj.$data[itemkey];
              }
            }
            props.set = function (val) {
              let args = Array.prototype.slice.call(arguments);
              addEvent(key, val);
              return _oldSet.apply(this, args);
            };
          }
        }
      }
    } catch (error) {
      console.error(error);
    }

    return _oldDefineProperty.call(this, obj, key, props);
  };
};
